import React from "react";
import { observer } from "mobx-react-lite";
import { NavLink } from "react-router-dom";

import useThemeService from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";

export interface MenuItemProps {
  id: string;
  labelKey: string;
  path: string;
  canAccess: boolean;
  disabled?: boolean;
  isActive?: boolean;
}

export default observer(function MenuItem(props: MenuItemProps) {
  const { id, labelKey, path, disabled, canAccess, isActive } = { ...props };
  const { themeClass } = useThemeService();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (disabled) {
      e.preventDefault();
    }
  };

  if (!canAccess) return null;

  return (
    <NavLink
      id={id}
      onClick={handleClick}
      key={labelKey}
      to={path}
      className={
        disabled
          ? themeClass(["secondary-menu-items"], ["disabled"])
          : themeClass(["secondary-menu-items"])
      }
      activeClassName="selected"
      isActive={(_, location) => {
        if (location.pathname === path)
          return true;
        return !!isActive;
      }}
      exact
    >
      <span className="secondary-menu-text">{translationService.translate(labelKey)}</span>
    </NavLink>
  );
});
